import { create } from 'zustand';

import { PROPOSAL_PAGE_SIZE, type ProposalOrderKey, type ProposalStatus } from './proposals';

interface ProposalsQueryState {
  search: string;
  status: 'All' | ProposalStatus;
  order: ProposalOrderKey;
  page: number;
  pageSize: number;
  setSearch: (search: string) => void;
  setStatus: (status: 'All' | ProposalStatus) => void;
  setOrder: (order: ProposalOrderKey) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  reset: () => void;
}

const defaults: Pick<ProposalsQueryState, 'search' | 'status' | 'order' | 'page' | 'pageSize'> = {
  search: '',
  status: 'All',
  order: 'newest',
  page: 1,
  pageSize: PROPOSAL_PAGE_SIZE,
};

/**
 * Query state for the proposals list (search, filter, sort, pagination).
 * Kept outside the component so it survives navigation. Cached data lives in
 * the resource cache (`useProposals` / `useResource`), not here.
 */
export const useProposalsStore = create<ProposalsQueryState>((set) => ({
  ...defaults,

  setSearch: (search) => set({ search, page: 1 }),
  setStatus: (status) => set({ status, page: 1 }),
  setOrder: (order) => set({ order, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize, page: 1 }),

  reset: () => set(defaults),
}));
